import React, {useEffect, useState} from "react";
import {useTypedSelector} from "../reducers";
import ContentVisual from "../components/ContentVisual";
import FindId from "../components/FindId";


const FindIdPage = () => {
    const { site, status } = useTypedSelector(state => state.profile);

    useEffect(() => {
        if(status === 'idle') return;
    }, [ status ]);

    return (
      <div className={'find-id-page-wrapper'}>
        <ContentVisual title={'아이디 / 비밀번호 찾기'} />
        <div className={'login-content-wrapper wrapper'}>
          <FindId />
        </div>
      </div>
    );
}

export default FindIdPage;
